<ng-container *ngIf="user">
  <app-data-table-layout
    [actionsConfig]="{
      showBackButton: true,
      showDownload: false,
      }"
    [currentValidationErrors]="currentValidationErrors"
    [columns]="columns"
    [resultSet]="resultSet"
    [editForms]="editForms"
    [editItemID]="editItemID"

    [currentPage]="currentPage"
    [totalPages]="totalPages"

    [generateLink]="generateLinkFn"

    (editStart)="onEditStart($event)"
    (deleteStart)="onDeleteStart($event)"
    (editSave)="onEditSave()"
    (editCancel)="onEditCancel()"
    (createStart)="onCreateStart()"
    (CSVDownload)="onDownloadCSV()"
    (goBack)="onGoBack()"
    (search)="onSearch($event)"

    (currentPageChange)="onPageChange($event)"
    (goToFirstPage)="onFirstPage()"
    (goToPrevPage)="onPrevPage()"
    (goToNextPage)="onNextPage()"
    (goToLastPage)="onLastPage()"
  />
</ng-container>
<app-details-view
  [(showModal)]="showModal"
  [columns]="columnsForCreate"
  title="Create {{ modelName }}"
  (save)="onCreate($event)"
></app-details-view>
<app-confirm-dialog
  *ngIf="showConfirmDialog"
  [title]="'Confirm Action'"
  [message]="confirmMessage"
  (confirm)="handleConfirm()"
  (cancel)="handleCancel()"
></app-confirm-dialog>
